// Used for benefits rows - subventions, ret flex, and user details
export default {
  computed: {
    // usado en UserBenefitsTableRow
    hasFoodFlexibleRemuneration () {
      return this.user.mealFlexRemActivated
    },
        // usado en UserBenefitsTableRow

    hasTransportFlexibleRemuneration () {
      return this.user.transportFlexRemActivated
    },
        // usado en UserBenefitsTableRow

    hasNurseryFlexibleRemuneration () {
      return this.user.nurseryFlexRemActivated
    },
        // usado en UserBenefitsTableRow

    hasInsuranceFlexibleRemuneration () {
      return this.user.insuranceFlexRemActivated
    },
        // usado en UserBenefitsTableRow

    hasEducationFlexibleRemuneration () {
      return this.user.educationFlexRemActivated
    }

  },
  methods: {
    // usado en UsersBenefitsTableRow
    handleConfirmFeatureDeactivation (feature, activityGroup) {
      if (this.hasAccumulativeBenefits) {
        let budgetToCheck = this.user.flexibleRemunerationUserBudgets.find(
          el => el.activityGroup.code === activityGroup
        )
        if (budgetToCheck && budgetToCheck.flexRemAssigned > 0) {
          // Feature exists so is going to be removed
          this.$emit('showConfirmDeactivationModal', {
            feature: feature,
            activityGroup: activityGroup,
            id: this.user.id
          })
        } else {
          this.setUserFeature(this.user.id, feature)
        }
      } else {
        this.setUserFeature(this.user.id, feature)
      }
    },
    // Interno
    // Se usa tb en UserRetFlexIndex, candidato a moverse
    // Se usa en UserSocialBenefitsTableRow
    // async setUserFeature (userId, feature) {
    //   let user = this.$store.getters['UsersStore/users'].find(
    //     el => el.id === userId
    //   )

    //   let featuresToAdd = user.activatedFeatures
    //   let featureToAddExists = user.activatedFeatures.findIndex(
    //     el => el.feature.code === feature
    //   )

    //   if (
    //     (!user.grossSalary ||
    //       user.grossSalary < MINIMUM_GROSS_SALARY_RET_FLEX) &&
    //     featureToAddExists < 0
    //   ) {
    //     this.$emit('showRequestGrossSalaryModal', {
    //       featureRequested: feature,
    //       userId: this.user.id
    //     })
    //     return
    //   }

    //   let segmentBenefitUpdatedTraits = {
    //     user_id: '',
    //     benefit_updated: '',
    //     status: ''
    //   }
    //   // Feature doesnt exist
    //   if (!(featureToAddExists !== -1)) {
    //     let { id: featureToBeAddedId, name: featureName } = this.features.find(
    //       el => el.code === feature
    //     )
    //     featuresToAdd.push({ feature: { id: featureToBeAddedId } })
    //     segmentBenefitUpdatedTraits.user_id = user.id
    //     segmentBenefitUpdatedTraits.benefit_updated = featureName
    //     segmentBenefitUpdatedTraits.status = true
    //   } else {
    //     // Feature exists, remove it

    //     let featureToRemove = user.activatedFeatures.find(
    //       el => el.feature.code === feature
    //     )

    //     featuresToAdd.splice(featureToAddExists, 1)
    //     segmentBenefitUpdatedTraits.user_id = user.id
    //     segmentBenefitUpdatedTraits.benefit_updated =
    //       featureToRemove.feature.name
    //     segmentBenefitUpdatedTraits.status = false
    //   }

    //   let updateInformation = {
    //     id: user.id,
    //     activatedFeatures: [...featuresToAdd]
    //   }

    //   await this.$store.dispatch('UsersStore/updateUser', updateInformation)
    //   segmentTrack('User benefit updated', segmentBenefitUpdatedTraits)
    // },
    // Usado en UserBenefitTableRow
    async handleRetFlexBudgetLimits (
      budgetName,
      limit,
      assignedOrMonthly = true
    ) {
      let budget = this.findBudgetToUpdate(budgetName)

      if (!budget) return

      let budgetLimitConfiguration = {
        id: budget.id
      }
      if (assignedOrMonthly) {
        budgetLimitConfiguration.flexRemAssigned = limit
      } else {
        budgetLimitConfiguration.flexRemMonthlyAssigned = limit
      }
      this.budgetToUpdate = {
        userBudgetsLimits: [{ ...budgetLimitConfiguration }]
      }
      this.budgetToUpdate.flexRetributionName = this.generateSegmentFlexRetKey(
        budgetName
      )
      try {
        await this.submitChange()
        // Refactor => esto no se usa ya
        this.retFlexIsGreaterThanExemptAllowed()
      } catch (error) {
        this.resetLimitValue(budgetName, assignedOrMonthly)
      }
    },
    // Interno
    generateSegmentFlexRetKey (budgetName) {
      let segmentFlexRetKey = ''
      switch (budgetName) {
        case 'RESTAURANTS':
          segmentFlexRetKey = 'Flexible retribution meals'
          break

        case 'TRANSPORTS':
          segmentFlexRetKey = 'Flexible retribution transports'
          break
        default:
          break
      }
      return segmentFlexRetKey
    },
    // Interno
    resetLimitValue (budgetName, assignedOrMonthly) {
      switch (budgetName) {
        case 'RESTAURANTS':
          assignedOrMonthly
            ? (this.assignedFood = this.foodAssigned)
            : (this.monthlyAssignedFood = this.foodMonthlyAssigned)
          break
        case 'TRANSPORT':
          assignedOrMonthly
            ? (this.assignedTransport = this.transportAssigned)
            : (this.monthlyAssignedTransport = this.transportMonthlyAsigned)
          break
        case 'INSURANCE':
          this.assignedInsurance = this.insuranceAssigned
          break

        case 'NURSERY':
          this.assignedNursery = this.nurseryAssigned
          break

        case 'EDUCATION':
          this.assignedEducation = this.educationAssigned
          break

        default:
          break
      }
    },
    // interno
    // Se usa en UserSocialBenefitsTableRow
    findBudgetToUpdate (activityGroup) {
      return (
        this.user &&
        this.user.flexibleRemunerationUserBudgets.find(
          el => el.activityGroup.code === activityGroup
        )
      )
    }
  }
}
